import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
  // TODO: Add SDKs for Firebase products that you want to use
  // https://firebase.google.com/docs/web/setup#available-libraries

  // Your web app's Firebase configuration
  const firebaseConfig = {
    apiKey: "AIzaSyC9tf1thC0WnTSSN1FkHKpJecUlwuTr7qQ",
    authDomain: "sintuff-sec.firebaseapp.com",
    projectId: "sintuff-sec",
    storageBucket: "sintuff-sec.firebasestorage.app",
  };

  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
  export default app;
  export const storage = getStorage(app);
